import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100vw;
  min-height: 100vh;
  background-color: #ffffff;

  @media (max-width: 900px) {
    flex-direction: column-reverse;
  }
`;

export const LeftPanel = styled.div`
  flex: 0 0 504px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0 64px;
  gap: 32px;

  @media (max-width: 900px) {
    flex: 1 1 auto;
    padding: 48px 24px;
    align-items: center;
    text-align: center;
  }
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 376px;
`;

export const Title = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #222222;
  margin: 0;
`;

export const Description = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #4f4f4f;
  margin: 0;
  white-space: pre-line;
`;

export const RightPanel = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5faff;
  padding: 48px;

  @media (max-width: 900px) {
    flex: 1 1 auto;
    padding: 24px;
  }
`;

export const Illustration = styled.img`
  width: 100%;
  max-width: 520px;
  height: auto;
  object-fit: contain;
`;
